<p-dialog [(visible)]="blastLoaded" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'envelope-circle-check']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">{{ blast.name }}</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<div class="d-flex display-14">
		<div class="m-2">
			{{ blast.description }}
		</div>
	</div>
	<div class="d-flex display-14">
		<div class="p-grid w-100">
			<div class="p-col-12 p-md-3 d-flex">{{ blast.sendCount }} sends</div>
			<div class="p-col-12 p-md-3" *ngIf="blast.openCount">{{ blast.openCount }} opens</div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-md-3">
			<a [routerLink]="['/cc/marketing/templates/' + blast.templateKey]" [queryParams]="{ bk: blast.sk }">{{ blast.templateName }}</a>
		</div>
		<div class="p-col-12 p-md-3">
			<ng-container *ngFor="let rec of blast.blastGroup"> {{ rec.name }} ({{ rec.lastCountResult }} members) </ng-container>
		</div>
	</div>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="customerList"
		[loading]="!customerList"
		[globalFilterFields]="app.keys(customerList)"
		[rows]="100"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header" #header>
			<tr>
				<th pSortableColumn="customer.lastName">
					<div class="d-flex justify-content-between">
						<div>Customer</div>
						<div>
							<p-sortIcon field="customer.lastName"></p-sortIcon>
						</div>
					</div>
				</th>
				<th pSortableColumn="openCount">
					<div class="d-flex justify-content-between">
						<div>Opens</div>
						<div>
							<p-sortIcon field="openCount"></p-sortIcon>
						</div>
					</div>
				</th>
				<th pSortableColumn="clickCount">
					<div class="d-flex justify-content-between">
						<div>Clicks</div>
						<div>
							<p-sortIcon field="clickCount"></p-sortIcon>
						</div>
					</div>
				</th>
				<th pSortableColumn="engagementCount">
					<div class="d-flex justify-content-between">
						<div>Engagements</div>
						<div>
							<p-sortIcon field="engagementCount"></p-sortIcon>
						</div>
					</div>
				</th>
				<th pSortableColumn="unsubscribe">
					<div class="d-flex justify-content-between">
						<div>Unsubscribed</div>
						<div>
							<p-sortIcon field="unsubscribe"></p-sortIcon>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" #body let-rec>
			<tr>
				<td class="d-flex flex-column">
					<div>{{ app.references.toTitleCase(rec.customer.lastName) }}, {{ app.references.toTitleCase(rec.customer.firstName) }}</div>
					<div>
						{{ rec.customer.email.toLowerCase() }}
					</div>
				</td>
				<td>
					<div>
						{{ rec.openCount }}
					</div>
					<div></div>
				</td>
				<td>
					{{ rec.clickCount }}
				</td>
				<td>
					{{ rec.engagementCount }}
				</td>
			</tr>
		</ng-template>
	</p-table>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]="false"
			[hideDelete]="true"
			[hideSave]="true"
			(onCancelChange)="blast = undefined; blastChange.emit(undefined)"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
